<template>
  <button
    @click="autopilotUpdateAction"
    :disabled="disabled"
    title="Update the enrollment status of the current selection"
  >
    <span> Update <font-awesome-icon icon="retweet"></font-awesome-icon> </span>
  </button>
</template>
<script>
export default {
  name: "AutopilotUpdateAction",
  props: {
    disabled: Boolean,
    selectOrFilter: Object
  },
  methods: {
    autopilotUpdateAction() {
      this.$emit("autopilotUpdateAction", this.selectOrFilter);
    }
  }
};
</script>
